import { useContext, useEffect } from "react";
import { Chart } from "react-google-charts";
import { useNavigate } from "react-router-dom";
import UserContext from "../../context/UserContext";
import "./IndividualStats.scss";

const IndividualStats = ({ pupilData }) => {
  const { user, getRounds } = useContext(UserContext);
  const navigate = useNavigate();

  useEffect(() => {
    if (user.isAdmin) {
      return () => {
        navigate("/stats-page");
      };
    }
  }, [user]);

  const options = {
    hAxis: {
      title: "N° OF ATTEMPTS",
      minValue: 0,
      maxValue: 6,
      textStyle: { color: "#FFFFFF" },
      titleTextStyle: { color: "#FFFFFF" },
    },
    vAxis: {
      title: "SCORE(%)",
      minValue: 0,
      maxValue: 100,
      textStyle: { color: "#FFFFFF" },
      titleTextStyle: { color: "#FFFFFF" },
    },
    curveType: "function",
    pointSize: 10,
    backgroundColor: "#1e2332",
    legend: {
      textStyle: {
        color: "#FFFFFF",
      },
    },
  };

  const correctPhonemes = getRounds(
    "swing",
    true,
    (pupilData && pupilData) || user
  );
  const incorrectPhonemes = getRounds(
    "swing",
    false,
    (pupilData && pupilData) || user
  );

  const correctJSX = correctPhonemes?.map((e) => {
    return <li key={e.phonic + e.roundTime.nanoseconds}>{e.phonic}</li>;
  });

  const incorrectJSX = incorrectPhonemes?.map((e) => {
    return <li key={e.phonic + e.roundTime.nanoseconds}>{e.phonic}</li>;
  });

  return (
    <section className="individual-stats">
      <div className="individual-stats__top-line">
        <img
          className="individual-stats__avatar"
          src={(pupilData && pupilData.avatar) || user?.avatar}
          alt="avatar"
        />
        <h1 className="individual-stats__heading">
          Stats for{" "}
          {(pupilData && pupilData.childName) ||
            (user?.childName ?? "loading...")}
        </h1>
      </div>
      {pupilData && (
        <div className="individual-stats__parent-info">
          <p className="individual-stats__parent-info-text">
            {pupilData.parent && "Parent name: " + pupilData.parent.name}
          </p>
          <p className="individual-stats__parent-info-text">
            {pupilData.parent &&
              "Parent email address: " + pupilData.parent.email}
          </p>
        </div>
      )}
      <div className="individual-stats__container">
        <div className="individual-stats__score-graph">
          <h2>Score Over Time</h2>
          <Chart
            chartType="LineChart"
            data={[
              [
                "N° of Attempts",
                (pupilData && pupilData.childName) || user?.childName,
              ],
              [1, 40],
              [2, 70],
              [3, 60],
              [4, 80],
            ]}
            options={options}
            legendToggle
          />
        </div>
        <div className="individual-stats__phonemes-container">
          <div className="individual-stats__phonemes">
            <h2>Correct Phonemes</h2>
            <ul>{correctJSX}</ul>
          </div>
          <div className="individual-stats__phonemes">
            <h2>Incorrect Phonemes</h2>
            <ul>{incorrectJSX}</ul>
          </div>
        </div>
      </div>
    </section>
  );
};

export default IndividualStats;
